const slideSelector = '.slideshow-slide.swiper-slide.slideshow-hero';
const heroSlides = document?.querySelectorAll(slideSelector);

if (heroSlides?.length) {
  const singleSlides = document?.querySelectorAll(
    '.slideshow-slide.swiper-slide.slideshow-hero.slideshow-slide--single'
  );

  if (heroSlides.length === singleSlides?.length) {
    changeSlideshowHeading();
  } else {
    const observer = new MutationObserver((mutations) => {
      const hasClassChange = mutations.some(
        (mutation) =>
          mutation.type === 'attributes' && mutation.attributeName === 'class'
      );

      if (!hasClassChange) return;
      changeSlideshowHeading();
    });

    heroSlides.forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  }
}

function changeSlideshowHeading() {
  const allSlideshowSlides = document?.querySelectorAll(slideSelector);
  if (!allSlideshowSlides?.length) return;

  const firstHeroSlide = [...allSlideshowSlides].find((slide) => {
    const isSingle = slide.classList.contains('slideshow-slide--single');
    const isFirstHeroSlide = slide.dataset.slide === '1' && slide.dataset.swiperSlideIndex === '0';

    return isFirstHeroSlide || isSingle;
  });

  allSlideshowSlides.forEach((slide) => {
    const heading = slide.querySelector(
      '.slideshow-slide__text-container-heading'
    );
    if (!heading) return;

    changeHeadingTag(heading, slide === firstHeroSlide ? 'H1' : 'H2');
  });
}

function changeHeadingTag(heading, tagName) {
  if (!heading || heading.tagName === tagName) return;

  const newHeading = document.createElement(tagName.toLowerCase());

  for (const attribute of heading.attributes) {
    newHeading.setAttribute(attribute.name, attribute.value);
  }

  while (heading.firstChild) {
    newHeading.appendChild(heading.firstChild);
  }

  heading.parentNode.replaceChild(newHeading, heading);
}
